import _ from "lodash";
import * as Actions from "../Actions/MinhasTarefasActions";

const initialState = {
    data: null,
    fluxo: null,
    pessoa: null,
    error: null,
    info: null,
    warning: null,
    minhatarefa: null,
    fluxosempresa: null,
    profissionaisempresa: null,
    produtosempresa: null,
    especialidadesempresa: null,
    atendimentos: null,
    fluxodisponibilidade: null,
    novoDialog: null,
};

const MinhasTarefasReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_MINHASTAREFAS:
            {
                return {
                    ...state,
                    data: action.payload,
                    novoDialog: null,
                };
            }
        case Actions.GET_MINHATAREFA:
            {
                return {
                    ...state,
                    minhatarefa: action.payload,
                };
            }
        case Actions.MINHASTAREFAS_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.MINHASTAREFAS_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                    id: action.id
                };
            }
        case Actions.MINHASTAREFAS_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        case Actions.GET_FLUXO:
            {
                return {
                    ...state,
                    fluxo: action.payload,
                };
            }
        case Actions.GET_MINHASTAREFAS_PESSOA:
            {
                return {
                    ...state,
                    pessoa: {
                        "data": action.data,
                        "contatos": action.contatos,
                        "enderecos": action.enderecos,
                        "relacionamentos": action.relacionamentos,
                        "formularios": action.formularios,
                        "tags": action.tags,
                    }
                };
            }
        case Actions.GET_MINHASTAREFAS_ATENDIMENTOS:
            {
                if (!_.isNull(action.atendimentos)) {
                    action.atendimentos.forEach(item => {
                        if (item.idtarefa === state.minhatarefa.idtarefa) {
                            state.minhatarefa.formulario = item.formulario;
                        }
                    });
                }

                return {
                    ...state,
                    atendimentos: !_.isNull(action.atendimentos) ? action.atendimentos.filter((value) => value.idtarefa !== state.minhatarefa.idtarefa) : null
                };
            }
        case Actions.CLEAR_ATENDIMENTOS:
            {
                return {
                    ...state,
                    atendimentos: null
                };
            }

        case Actions.CLEAR_DISPONIBILIDADE:
            {
                return {
                    ...state,
                    fluxodisponibilidade: null

                };
            }


        case Actions.GET_FLUXOSEMPRESA:
            {
                return {
                    ...state,
                    fluxosempresa: action.payload
                };
            }
        case Actions.GET_PROFISSIONAISEMPRESA:
            {
                return {
                    ...state,
                    profissionaisempresa: action.payload
                };
            }
        case Actions.GET_PRODUTOSEMPRESA:
            {
                return {
                    ...state,
                    produtosempresa: action.payload
                };
            }
        case Actions.GET_ESPECIALIDADESEMPRESA:
            {
                return {
                    ...state,
                    especialidadesempresa: action.payload
                };
            }
        case Actions.GET_TAREFAS_PASSADO:
            {
                var AArray = JSON.parse(JSON.stringify(state.data));
                var Obj = _.find(AArray, { idtarefa: action.idtarefa });
                Obj.detalhes = action.payload;

                AArray.forEach(item => {
                    if (item.idtarefa === Obj.idtarefa) {
                        item = Obj;
                    }
                });

                return {
                    ...state,
                    data: AArray
                };
            }

        case Actions.OPEN_NOVO_DIALOG:
            {
                return {
                    ...state,
                    novoDialog: action.payload,
                    fluxodisponibilidade: null
                };
            }
        default:
            {
                return state;
            }
    }
};

export default MinhasTarefasReducer;
